import { Avatar, Button, Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '../../../assets/icons';
import { APP_URLS } from '../../../routes/urls';
import { openQualificationDrawer, updateGuestUser } from '../../../store/features/qualification/qualificationSlice';
import { useAppDispatch } from '../../../store/hooks';
import { GuestUser } from '../../../types/qualification';
import { AppIcon } from '../../app-icon/AppIcon';
import { accountMenuStyles } from './styles';

interface GuestUserAccountMenuProps {
  guestUser: GuestUser;
}

export const GuestUserAccountMenu: React.FC<GuestUserAccountMenuProps> = ({ guestUser }) => {
  const menuAnchorEl = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleIsMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const dispatch = useAppDispatch();
  const showQualificationForm = (): void => {
    dispatch(openQualificationDrawer());
  };

  const removeGuestAccount = (): void => {
    dispatch(updateGuestUser(null));
  };
  return (
    <>
      <Button
        startIcon={<Avatar sx={{ width: '1.75rem', height: '1.75rem' }}>{guestUser.full_name[0]}</Avatar>}
        endIcon={<AppIcon sx={accountMenuStyles.myAccountIcon} Icon={ChevronDownIcon} />}
        ref={menuAnchorEl}
        onClick={toggleIsMenuOpen}
        color="primary"
        variant="text"
        size="small"
        component="button"
      >
        {guestUser.full_name}
      </Button>
      <Menu
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorEl={menuAnchorEl.current}
        open={isMenuOpen}
        onClose={toggleIsMenuOpen}
        onClick={toggleIsMenuOpen}
      >
        <MenuItem sx={accountMenuStyles.accountMenuItem} onClick={showQualificationForm}>
          Manage qualification
        </MenuItem>
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.signIn}>
          Sign In
        </MenuItem>
        <MenuItem component={Link} sx={accountMenuStyles.accountMenuItem} to={APP_URLS.signUp}>
          Create New Account
        </MenuItem>
        <MenuItem sx={accountMenuStyles.accountMenuItem} onClick={removeGuestAccount}>
          Remove guest account
        </MenuItem>
      </Menu>
    </>
  );
};
